import Pledge from './index';
import Coefficient from './Coefficient';
import Interest from './Interest';

export default {
  path: '/home/pledge',
  component: Pledge,
  redirect: '/home/pledge/coefficient',
  children: [
    { path: '/home/pledge/coefficient', component: Coefficient },
    { path: '/home/pledge/interest/:pledgeId?', component: Interest }
  ]
};
